import React,{Component} from 'react';
import info from './img/info.png';
import croix from './img/croix.png';
class InfoBulle extends Component {
	state ={
		display:false,
	}
	displayContent = ()=>{
		this.setState (({display})=>{
			return {display:!display};
		});
	}

	infoBtnStyle= {
    	background: `url(${info})top left no-repeat`,
    	cursor: 'pointer',
    	paddingBottom: '2px',
    	backgroundSize:'20px',
    	marginLeft : '5px'
	}

	render(){
		return <>
			
			<span onClick={this.displayContent} className="info" style={this.infoBtnStyle}>+ d'infos</span>
			{
				(this.state.display) ? 
					<div className="info-bulle">
					  <div>
					    <div>
					      <img src={info} alt="Info" className="info-img" />
					      <span>Infos</span>
					    </div>
					    <div>
					      <img  src={croix}alt="Croix info" onClick={this.displayContent}/>
					    </div>
					  </div>
					  <div >{this.props.message}</div>
					</div>
					: ""
			}
		</>

	}
}
export default InfoBulle;